




























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AmetrasResponsiveTabBar from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import AmetrasDynamicContent from '@/views/AmetrasDynamicContent.vue';
import {FormularInstance} from './formular/form.interface';
import {DIALOG_STACK_INSTANCE, DialogInstance} from '@/utils/dialog.stack';

/**
 * This is a component that can render dynamic contents
 */
@Component({
  name: 'ametras-dynamic-content-dialog',
  components: {
    AmetrasDynamicContent,
    LazyDataTableTemplate: () => import('./datatable/DataTableTemplate.vue'),
    LazyFormTemplate: () => import('./formular/FormTemplate.vue'),
    AmetrasResponsiveTabBar
  }
})
export default class AmetrasDynamicContentDialog extends Vue implements DialogInstance {

  @Prop() show!: boolean;
  @Prop() fixedTop!: boolean;
  @Prop() fullscreen!: boolean;
  @Prop() maxWidthInPx!: number;
  @Prop() width!: string | number;
  @Prop() dynamicContent!: DisguiseDto.DynamicContentUnion;
  // optional and used in formular only
  @Prop() overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
  @Prop() contentTitle!: string;
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) editKey!: CompositeKeyType;
  @Prop() object!: any;
  @Prop() handleDialogCloseEventSeparately!: boolean;
  // a value indicating that the tabs must be rerendered
  tabRenderKeyCount: number = 0;
  // if the view contains a formular, then this member holds the instance
  formularInstance: FormularInstance | null = null;
  showDialog: boolean = false;
  hideOverlay: boolean = false;

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });

  mounted() {
    if (this.show) {
      DIALOG_STACK_INSTANCE.registerDialog(this);
      this.showDialog = true;
    }
  }

  destroyed() {
    DIALOG_STACK_INSTANCE.unregisterDialog(this);
  }

  @Watch('show') onShowChanged(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      if (newValue) {
        DIALOG_STACK_INSTANCE.registerDialog(this);
        this.showDialog = true;
      } else {
        DIALOG_STACK_INSTANCE.unregisterDialog(this);
        this.showDialog = false;
      }
    }
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

  closeDialog(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.handleDialogCloseEventSeparately) {
      this.$emit('closeDialog');
    } else {
      this.$emit('close');
    }
  }

  afterFormularInitialized(formularInstance: FormularInstance) {
    this.formularInstance = formularInstance;
  }
}
